import { createContext } from 'react';
import { Locale } from '@/i18n';
import { WidgetSdk } from '@/sdk';

export type ProviderContextValue = {
  sdk: WidgetSdk;
  i18n?: Locale;
  // theme?: Theme;
};

export const ProviderContext = createContext<ProviderContextValue | null>(null);
